import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthRoute } from '@portal-core/auth/enums/auth-route.enum';
import { AuthRouteService } from '@portal-core/auth/services/auth-route.service';
import { AuthService } from '@portal-core/auth/services/auth.service';

export const authGuard: CanActivateFn = (): boolean => {
  const authService = inject(AuthService);
  const authRouteService = inject(AuthRouteService);

  if (!authService.isAuthenticated()) {
    authRouteService.navigateToAuthRoute$(AuthRoute.Login).subscribe();
    return false;
  } else {
    return true;
  }
};
